import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=71c0e238&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=js&"
export * from "./Brands.vue?vue&type=script&lang=js&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=71c0e238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0e238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c0e238')) {
      api.createRecord('71c0e238', component.options)
    } else {
      api.reload('71c0e238', component.options)
    }
    module.hot.accept("./Brands.vue?vue&type=template&id=71c0e238&scoped=true&", function () {
      api.rerender('71c0e238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Brands/Brands.vue"
export default component.exports